<div class="checkout-page">

  <div class="checkout-container">

    <div class="checkout-card">

      <h1>
        Só mais um pouco!
      </h1>

      <p class="subtitle">
        Informe os dados do cartão
      </p>


      <h3>
        Dados do cartão
      </h3>


      <div class="form-grid">

        <!-- Número do cartão -->
        <div class="campo campo-full">

          <label>
            Número do cartão
          </label>

          <input
            type="text"
            maxlength="19"
            placeholder="0000 0000 0000 0000"
            [(ngModel)]="numeroCartao"
            (input)="formatarCartao()"
          />

        </div>


        <!-- Nome -->
        <div class="campo campo-full">

          <label>
            Nome impresso no cartão
          </label>

          <input
            type="text"
            placeholder="Nome completo"
            [(ngModel)]="nomeCartao"
          />

        </div>


        <!-- Validade -->
        <div class="campo">

          <label>
            Validade
          </label>

          <input
            type="text"
            maxlength="5"
            placeholder="MM/AA"
            [(ngModel)]="validadeCartao"
            (input)="formatarValidade()"
          />

        </div>


        <!-- CVV -->
        <div class="campo">

          <label>
            CVV
          </label>

          <input
            type="password"
            maxlength="4"
            placeholder="CVV"
            [(ngModel)]="cvv"
          />

        </div>


        <!-- CPF -->
        <div class="campo campo-full">

          <label>
            CPF do titular
          </label>

          <input
            type="text"
            maxlength="14"
            placeholder="000.000.000-00"
            [(ngModel)]="cpfCartao"
            (input)="formatarCpf()"
          />

        </div>


        <!-- Parcelamento -->
        <div class="campo campo-full">

          <label for="parcelas">
            Parcelamento
          </label>


          <select
            id="parcelas"
            name="parcelas"
            [(ngModel)]="parcelas"
            [disabled]="!opcoesParcelamento.length"
          >

            <option
              *ngFor="let opcao of opcoesParcelamento"
              [ngValue]="opcao.parcelas"
            >

              {{ opcao.parcelas }}x de
              R$
              {{ opcao.valorParcela | number:'1.2-2' }}

              <span
                *ngIf="opcao.parcelas === 1"
              >
                à vista
              </span>

            </option>

          </select>

        </div>

      </div>


      <!-- Segurança -->
      <div class="seguranca">

        🔒 Seus dados de pagamento são tratados
        de forma segura.

      </div>


      <!-- Botões -->
      <div class="actions">

        <button
          class="btn-voltar"
          type="button"
          (click)="voltar()"
        >
          Voltar
        </button>


        <button
          class="btn-pagar"
          type="button"
          [disabled]="
            processando ||
            !opcoesParcelamento.length
          "
          (click)="confirmarPagamento()"
        >

          <span *ngIf="!processando">

            Confirmar e Pagar

          </span>


          <span *ngIf="processando">

            Processando...

          </span>

        </button>

      </div>

    </div>


    <!-- RESUMO -->
    <div class="resumo-card">

      <div class="resumo-topo">

        <img
          [src]="dados?.quartoImagem"
        />


        <div>

          <h3>
            {{ dados?.quartoNome }}
          </h3>


          <p>
            {{ descricaoAcomodacao }}
          </p>

        </div>

      </div>


      <!-- Datas -->
      <div class="resumo-linha">

        <strong>
          Datas
        </strong>

        <span>

          {{ formatarData(dados?.checkIn) }}

          -

          {{ formatarData(dados?.checkOut) }}

        </span>

      </div>


      <!-- Hóspedes -->
      <div class="resumo-linha">

        <strong>
          Hóspedes
        </strong>

        <span>

          {{ dados?.adultos }} adulto(s),

          {{ dados?.criancas }} criança(s)

          e

          {{ dados?.animais }} animal(is)

        </span>

      </div>


      <!-- Parcelamento -->
      <div class="resumo-linha">

        <strong>
          Parcelamento
        </strong>

        <span>

          <ng-container
            *ngIf="opcaoParcelamentoSelecionada"
          >

            {{ opcaoParcelamentoSelecionada.parcelas }}x
            de
            R$
            {{
              opcaoParcelamentoSelecionada.valorParcela
                | number:'1.2-2'
            }}

          </ng-container>


          <ng-container
            *ngIf="!opcaoParcelamentoSelecionada"
          >

            Carregando...

          </ng-container>

        </span>

      </div>


      <!-- Valor original da reserva -->
      <div class="resumo-linha">

        <strong>
          Valor da reserva
        </strong>

        <span class="valor">

          R$
          {{ valorTotal | number:'1.2-2' }}

        </span>

      </div>


      <!-- Total cobrado no cartão -->
      <div
        class="resumo-linha"
        *ngIf="opcaoParcelamentoSelecionada"
      >

        <strong>
          Total no cartão
        </strong>

        <span class="valor">

          R$
          {{
            opcaoParcelamentoSelecionada.valorTotal
              | number:'1.2-2'
          }}

        </span>

      </div>

    </div>

  </div>

</div>
